import { render, staticRenderFns } from "./occupationInfo.vue?vue&type=template&id=10eb7ea4&scoped=true"
import script from "./occupationInfo.vue?vue&type=script&lang=js"
export * from "./occupationInfo.vue?vue&type=script&lang=js"
import style0 from "./occupationInfo.vue?vue&type=style&index=0&id=10eb7ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb7ea4",
  null
  
)

export default component.exports